import { ComponentProps, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export default function Tooltip(props: ComponentProps<typeof ReactTooltip>) {
  const [portalContainer, setPortalContainer] = useState<Element | null>(null);

  useEffect(() => {
    const existingPortalRoot = document.getElementById('tooltip-portal-root');
    if (existingPortalRoot) {
      setPortalContainer(existingPortalRoot);
    } else {
      console.warn(
        "Tooltip portal root 'tooltip-portal-root' not found in the DOM. Tooltips may not render correctly on top of other elements."
      );
    }
  }, []);

  const tooltipElement = (
    <ReactTooltip
      clickable
      offset={8}
      style={{
        background: '#071031',
        boxShadow: '6px 4px 20px 0px rgba(0, 0, 0, 0.25)',
        padding: '8px 10px',
        borderRadius: '4px',
        color: 'white',
        zIndex: 100000,
        pointerEvents: 'auto',
        userSelect: 'text',
        cursor: 'text',
        ...props.style,
      }}
      openOnClick={false}
      delayHide={200}
      {...props}
    />
  );

  if (portalContainer) {
    return createPortal(tooltipElement, portalContainer);
  }
  return null;
}
